import React, { useEffect, useState } from "react";
import { useFormContext, useFieldArray, Controller } from "react-hook-form";
import {
  Row,
  Col,
  Button,
  Input,
  Label,
  FormFeedback,
  Alert,
  FormGroup,
} from "reactstrap";
import Switch from "react-switch";
import { Offsymbol, OnSymbol } from "@helpers/helpers";

const EpisodeForm = ({ data, route,selectedPurchaseType  }) => {
  
  const { control, errors, setValue } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "formRows",
  });

  const [uploadError, setUploadError] = useState(null);

  useEffect(() => {
    if (fields.length === 0) {
      append({
        sorting: "",
        name: "",
        media: {
          url: null,
          type: "",
          size: null,
          width: null,
          height: null,
        },
        duration: null,
        media_type: "",
        is_free: selectedPurchaseType === 1,
      });
    }
  }, [append,selectedPurchaseType]);

  const handleFileChange = (file, onChange, index) => {
    if (!file) return;
    
    const url = URL.createObjectURL(file);
    const isVideo = file.type.startsWith("video");
    const mediaElement = document.createElement(isVideo ? "video" : "audio");
  
    const maxDurationInSeconds = isVideo ? 600 : 7200; // 10 minutes for video, 120 minutes for audio
    const maxFileSizeInBytes = isVideo ? 1000 * 1024 * 1024 : 200 * 1024 * 1024; // 1000 MB for video, 200 MB for audio
  
    if (file.size > maxFileSizeInBytes) {
      setUploadError(
        `The uploaded file exceeds the maximum size of ${
          isVideo ? "1000 MB" : "200 MB"
        }.`
      );
      onChange(null);
      URL.revokeObjectURL(url);
      return;
    }
  
    const mediaType = file.type.split("/")[1] === "mp4" ? 2 : 1;
  
    mediaElement.src = url;
    mediaElement.onloadedmetadata = () => {
      const durationInSeconds = Math.floor(mediaElement.duration);
      const width = mediaElement.videoWidth || null;
      const height = mediaElement.videoHeight || null;
      const size = file.size;
  
      if (durationInSeconds > maxDurationInSeconds) {
        setUploadError(
          `The uploaded file exceeds the maximum duration of ${
            isVideo ? "10 minutes" : "120 minutes"
          }.`
        );
        onChange(null);
      } else {
        setUploadError(null);
        setValue(`formRows[${index}].media`, {
          url,
          type: file.type,
          size,
          width,
          height,
        });
        setValue(`formRows[${index}].duration`, durationInSeconds);
        setValue(`formRows[${index}].media_type`, mediaType);
        onChange(file);
      }
      URL.revokeObjectURL(url);
    };
  
    mediaElement.onerror = () => {
      console.error("Error loading media file");
      setUploadError("Error loading media file.");
      URL.revokeObjectURL(url);
    };
  };
  
  // const handleFileChange = (file, onChange, index) => {
  //   if (!file) return;

  //   const url = URL.createObjectURL(file);
  //   const mediaElement = document.createElement(
  //     file.type.startsWith("video") ? "video" : "audio"
  //   );

  //   const mediaType = file.type.split("/")[1] === "mp4" ? 2 : 1;

  //   mediaElement.src = url;
  //   mediaElement.onloadedmetadata = () => {
  //     const durationInSeconds = Math.floor(mediaElement.duration);
  //     const width = mediaElement.videoWidth || null;
  //     const height = mediaElement.videoHeight || null;
  //     const size = file.size;

  //     if (durationInSeconds > 60) {
  //       setUploadError(
  //         "The uploaded file exceeds the maximum duration of 60 seconds."
  //       );
  //       onChange(null);
  //     } else {
  //       setUploadError(null);
  //       setValue(`formRows[${index}].media`, {
  //         url,
  //         type: file.type,
  //         size,
  //         width,
  //         height,
  //       });
  //       setValue(`formRows[${index}].duration`, durationInSeconds);
  //       setValue(`formRows[${index}].media_type`, mediaType);
  //       onChange(file);
  //     }
  //     console.log("Duration:", durationInSeconds, "seconds");
  //     URL.revokeObjectURL(url);
  //   };
  //   mediaElement.onerror = () => {
  //     console.error("Error loading media file");
  //     setUploadError("Error loading media file.");
  //     URL.revokeObjectURL(url);
  //   };
  // };

  return (
    <>
      {fields.map((field, index) => (
        <div key={field.id}>
          <Row className="mb-3">
            <Col lg={6}>
              <Label for={`formRows[${index}].sorting`}>Sorting</Label>
              <Controller
                name={`formRows[${index}].sorting`}
                control={control}
                render={({ field }) => (
                  <Input
                    type="number"
                    {...field}
                    value={field.value || ""}
                    onChange={(e) =>
                      field.onChange(parseInt(e.target.value, 10))
                    }
                    invalid={!!errors.formRows?.[index]?.sorting}
                    placeholder="Sorting"
                  />
                )}
              />
              {errors.formRows?.[index]?.sorting && (
                <FormFeedback>
                  {errors.formRows[index].sorting.message}
                </FormFeedback>
              )}
            </Col>

            <Col lg={5}>
              <Label for={`formRows[${index}].media.url`}>Media File</Label>
              <Controller
                name={`formRows[${index}].media.url`}
                control={control}
                render={({ field }) => (
                  <div>
                    <Input
                      type="file"
                      accept="video/*,audio/*"
                      onChange={(e) =>
                        handleFileChange(
                          e.target.files[0],
                          field.onChange,
                          index
                        )
                      }
                      invalid={!!errors.formRows?.[index]?.media?.url}
                    />
                    {errors.formRows?.[index]?.media?.url && (
                      <FormFeedback>
                        {errors.formRows[index].media.url.message}
                      </FormFeedback>
                    )}
                    {uploadError && <Alert color="danger">{uploadError}</Alert>}
                  </div>
                )}
              />
            </Col>

            <Col lg={1} className="align-self-center mt-4">
              <Button
                type="button"
                className="btn btn-danger"
                onClick={() => remove(index)}
              >
                Delete
              </Button>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col lg={6}>
              <Label for={`formRows[${index}].name`}>Name</Label>
              <Controller
                name={`formRows[${index}].name`}
                control={control}
                render={({ field }) => (
                  <Input
                    type="text"
                    {...field}
                    invalid={!!errors.formRows?.[index]?.name}
                    placeholder="Enter Episode Name"
                  />
                )}
              />
              {errors.formRows?.[index]?.name && (
                <FormFeedback>
                  {errors.formRows[index].name.message}
                </FormFeedback>
              )}
            </Col>
            <Col md={6}>
              <Label for="is_user_text_input"> Is Free: </Label>
              <FormGroup>
                <Controller
                  name={`formRows[${index}].is_free`}
                  control={control}
                  render={({ field }) => (
                    <Switch
                      id="isUserSwitch"
                      onChange={(checked) => field.onChange(checked)}
                  checked={selectedPurchaseType === 1 ? true : field.value}
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      className="me-1 mb-sm-8 mb-2"
                      onColor="#02a499"
                    />
                  )}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col lg={3} className="d-none">
              <Label for={`formRows[${index}].duration`}>
                Duration (seconds)
              </Label>
              <Controller
                name={`formRows[${index}].duration`}
                control={control}
                render={({ field }) => (
                  <Input
                    type="number"
                    {...field}
                    value={field.value || ""}
                    readOnly
                  />
                )}
              />
            </Col>

            <Col lg={3} className="d-none">
              <Label for={`formRows[${index}].media_type`}>Media Type</Label>
              <Controller
                name={`formRows[${index}].media_type`}
                control={control}
                render={({ field }) => (
                  <Input
                    type="text"
                    {...field}
                    value={field.value === 2 ? "Video" : "Audio"}
                    readOnly
                  />
                )}
              />
            </Col>
          </Row>
        </div>
      ))}
      <Button
        type="button"
        className="btn btn-info mt-3"
        onClick={() =>
          append({
            sorting: "",
            name: "",
            media: {
              url: null,
              type: "",
              size: null,
              width: null,
              height: null,
            },
            duration: null,
            media_type: "",
            is_free: false,
          })
        }
      >
        Add
      </Button>
    </>
  );
};

export default EpisodeForm;

// import React, { useEffect, useState } from "react";
// import { useFormContext, useFieldArray, Controller } from "react-hook-form";
// import {
//   Row,
//   Col,
//   Button,
//   Input,
//   Label,
//   FormFeedback,
//   Alert,
//   FormGroup,
// } from "reactstrap";
// import Switch from "react-switch";
// import { Offsymbol, OnSymbol } from "@helpers/helpers";

// const EpisodeForm = ({ data, route }) => {
//   const { control, errors, setValue } = useFormContext();

//   const { fields, append, remove } = useFieldArray({
//     control,
//     name: "formRows",
//   });

//   const [uploadError, setUploadError] = useState(null);

//   useEffect(() => {
//     if (fields.length === 0) {
//       append({
//         sorting: "",
//         name: "",
//         media_url: null,
//         duration: null,
//         media_type: "",
//         is_free: false,
//       });
//     }
//   }, [append, fields.length]);

//   const handleFileChange = (file, onChange, index) => {
//     if (!file) return;

//     const url = URL.createObjectURL(file);
//     const mediaElement = document.createElement(
//       file.type.startsWith("video") ? "video" : "audio"
//     );

//     const mediaType = file.type.split("/")[1] === "mp4" ? 2 : 1;

//     mediaElement.src = url;
//     mediaElement.onloadedmetadata = () => {
//       const durationInSeconds = Math.floor(mediaElement.duration);
//       if (durationInSeconds > 60) {
//         setUploadError(
//           "The uploaded file exceeds the maximum duration of 60 seconds."
//         );
//         onChange(null);
//       } else {
//         setUploadError(null);
//         setValue(`formRows[${index}].duration`, durationInSeconds);
//         setValue(`formRows[${index}].media_type`, mediaType);
//         onChange(file);
//       }
//       console.log("Duration:", durationInSeconds, "seconds");
//       URL.revokeObjectURL(url);
//     };
//     mediaElement.onerror = () => {
//       console.error("Error loading media file");
//       setUploadError("Error loading media file.");
//       URL.revokeObjectURL(url);
//     };
//   };

//   return (
//     <>
//       {fields.map((field, index) => (
//         <div key={field.id}>
//           <Row className="mb-3">
//             <Col lg={6}>
//               <Label for={`formRows[${index}].sorting`}>Sorting</Label>
//               <Controller
//                 name={`formRows[${index}].sorting`}
//                 control={control}
//                 render={({ field }) => (
//                   <Input
//                     type="number"
//                     {...field}
//                     value={field.value || ""}
//                     onChange={(e) =>
//                       field.onChange(parseInt(e.target.value, 10))
//                     }
//                     invalid={!!errors.formRows?.[index]?.sorting}
//                     placeholder="Sorting"
//                   />
//                 )}
//               />
//               {errors.formRows?.[index]?.sorting && (
//                 <FormFeedback>
//                   {errors.formRows[index].sorting.message}
//                 </FormFeedback>
//               )}
//             </Col>

//             <Col lg={5}>
//               <Label for={`formRows[${index}].media_url`}>Media File</Label>

//               <Controller
//                 name={`formRows[${index}].media_url`}
//                 control={control}
//                 defaultValue={null}
//                 render={({ field }) => (
//                   <div>
//                     <Input
//                       type="file"
//                       accept="video/*,audio/*"
//                       onChange={(e) =>
//                         handleFileChange(
//                           e.target.files[0],
//                           field.onChange,
//                           index
//                         )
//                       }
//                       invalid={!!errors.formRows?.[index]?.media_url}
//                     />
//                     {errors.formRows?.[index]?.media_url && (
//                       <FormFeedback>
//                         {errors.formRows[index].media_url.message}
//                       </FormFeedback>
//                     )}
//                     {uploadError && <Alert color="danger">{uploadError}</Alert>}
//                   </div>
//                 )}
//               />
//             </Col>
//             {index > 0 && (
//               <Col lg={1} className="align-self-center mt-3">
//                 <Button
//                   type="button"
//                   className="btn btn-danger"
//                   onClick={() => remove(index)}
//                 >
//                   Delete
//                 </Button>
//               </Col>
//             )}
//           </Row>

//           <Row className="mb-3">
//             <Col lg={6}>
//               <Label for={`formRows[${index}].name`}>Name</Label>
//               <Controller
//                 name={`formRows[${index}].name`}
//                 control={control}
//                 render={({ field }) => (
//                   <Input
//                     type="text"
//                     {...field}
//                     invalid={!!errors.formRows?.[index]?.name}
//                     placeholder="Enter Episode Name"
//                   />
//                 )}
//               />
//               {errors.formRows?.[index]?.name && (
//                 <FormFeedback>
//                   {errors.formRows[index].name.message}
//                 </FormFeedback>
//               )}
//             </Col>
//             <Col md={6}>
//               <Label for="is_user_text_input"> Is Free: </Label>
//               <FormGroup>
//                 <Controller
//                   name={`formRows[${index}].is_free`}
//                   control={control}
//                   render={({ field }) => (
//                     <Switch
//                       id="isUserSwitch"
//                       onChange={(checked) => field.onChange(checked)}
//                       checked={field.value}
//                       uncheckedIcon={<Offsymbol />}
//                       checkedIcon={<OnSymbol />}
//                       className="me-1 mb-sm-8 mb-2"
//                       onColor="#02a499"
//                     />
//                   )}
//                 />
//               </FormGroup>
//             </Col>
//           </Row>

//           <Row className="mb-3">
//             <Col lg={3} className="d-none">
//               <Label for={`formRows[${index}].duration`}>
//                 Duration (seconds)
//               </Label>
//               <Controller
//                 name={`formRows[${index}].duration`}
//                 control={control}
//                 render={({ field }) => (
//                   <Input
//                     type="number"
//                     {...field}
//                     value={field.value || ""}
//                     readOnly
//                   />
//                 )}
//               />
//             </Col>

//             <Col lg={3} className="d-none">
//               <Label for={`formRows[${index}].media_type`}>Media Type</Label>
//               <Controller
//                 name={`formRows[${index}].media_type`}
//                 control={control}
//                 render={({ field }) => (
//                   <Input
//                     type="text"
//                     {...field}
//                     value={field.value === 2 ? "Video" : "Audio"}
//                     readOnly
//                   />
//                 )}
//               />
//             </Col>
//           </Row>
//         </div>
//       ))}
//       <Button
//         type="button"
//         className="btn btn-info mt-3"
//         onClick={() =>
//           append({
//             sorting: "",
//             name: "",
//             media_url: null,
//             duration: null,
//             media_type: "",
//             is_free: false,
//           })
//         }
//       >
//         Add
//       </Button>
//     </>
//   );
// };

// export default EpisodeForm;

// import React, { useEffect, useState } from "react";
// import { useFormContext, useFieldArray, Controller } from "react-hook-form";
// import {
//   Row,
//   Col,
//   Button,
//   Input,
//   Label,
//   FormFeedback,
//   Alert,
// } from "reactstrap";
// import { Link } from "react-router-dom";
// import ViewModal from "../custom-table/ViewModel";

// const EpisodeForm = ({ data, route }) => {
//   const { control, errors, setValue } = useFormContext();

//   const { fields, append, remove } = useFieldArray({
//     control,
//     name: "formRows",
//   });

//   const [viewModel, setViewModel] = useState(false);
//   const [viewImageUrl, setViewImageUrl] = useState("");
//   const [uploadError, setUploadError] = useState(null);

//   const handleViewImage = (imageUrl) => {
//     setViewImageUrl(imageUrl);
//     setViewModel(true);
//   };

//   useEffect(() => {
//     if (route === "edit") {
//       if (!data || data.length === 0) {
//         append({
//           sorting: "",
//           name: "",
//           media_url: null,
//           duration: null,
//           media_type: "",
//         });
//       }
//     } else {
//       if (fields.length === 0) {
//         append({
//           sorting: "",
//           name: "",
//           media_url: null,
//           duration: null,
//           media_type: "",
//         });
//       }
//     }
//   }, [data, append, fields.length, route]);

//   const handleFileChange = (file, onChange, index) => {
//     if (!file) return;

//     const url = URL.createObjectURL(file);
//     const mediaElement = document.createElement(
//       file.type.startsWith("video") ? "video" : "audio"
//     );

//     const mediaType = file.type.split("/")[1] === "mp4" ? 2 : 1;

//     mediaElement.src = url;
//     mediaElement.onloadedmetadata = () => {
//       const durationInSeconds = Math.floor(mediaElement.duration);
//       if (durationInSeconds > 60) {
//         setUploadError(
//           "The uploaded file exceeds the maximum duration of 60 seconds."
//         );
//         onChange(null);
//       } else {
//         setUploadError(null);
//         setValue(`formRows[${index}].duration`, durationInSeconds);
//         setValue(`formRows[${index}].media_type`, mediaType);
//         onChange(file);
//       }
//       console.log("Duration:", durationInSeconds, "seconds");
//       URL.revokeObjectURL(url);
//     };
//     mediaElement.onerror = () => {
//       console.error("Error loading media file");
//       setUploadError("Error loading media file.");
//       URL.revokeObjectURL(url);
//     };
//   };

//   return (
//     <>
//       {viewModel && (
//         <ViewModal
//           show={viewModel}
//           onCloseClick={() => setViewModel(false)}
//           data={viewImageUrl}
//         />
//       )}

//       {fields.map((field, index) => (
//         <div key={field.id}>
//           <Row className="mb-3">
//             <Col lg={6}>
//               <Label for={`formRows[${index}].sorting`}>Sorting</Label>
//               <Controller
//                 name={`formRows[${index}].sorting`}
//                 control={control}
//                 render={({ field }) => (
//                   <Input
//                     type="text"
//                     {...field}
//                     invalid={!!errors.formRows?.[index]?.sorting}
//                     placeholder="Sorting"
//                   />
//                 )}
//               />
//               {errors.formRows?.[index]?.sorting && (
//                 <FormFeedback>
//                   {errors.formRows[index].sorting.message}
//                 </FormFeedback>
//               )}
//             </Col>

//             <Col lg={5}>
//               <Label for={`formRows[${index}].media_url`}>
//                 Media File
//                 {route === "edit" ? (
//                   <Link
//                     className="ms-2"
//                     onClick={() => handleViewImage(field.image?.image_url)}
//                   >
//                     View
//                   </Link>
//                 ) : null}
//               </Label>

//               <Controller
//                 name={`formRows[${index}].media_url`}
//                 control={control}
//                 defaultValue={null}
//                 render={({ field }) => (
//                   <div>
//                     <Input
//                       type="file"
//                       accept="video/*,audio/*"
//                       onChange={(e) =>
//                         handleFileChange(e.target.files[0], field.onChange, index)
//                       }
//                       invalid={!!errors.formRows?.[index]?.media_url}
//                     />
//                     {errors.formRows?.[index]?.media_url && (
//                       <FormFeedback>
//                         {errors.formRows[index].media_url.message}
//                       </FormFeedback>
//                     )}
//                     {uploadError && <Alert color="danger">{uploadError}</Alert>}
//                   </div>
//                 )}
//               />
//             </Col>
//             {index > 0 && (
//               <Col lg={1} className="align-self-center mt-3">
//                 <Button
//                   type="button"
//                   className="btn btn-danger"
//                   onClick={() => remove(index)}
//                 >
//                   Delete
//                 </Button>
//               </Col>
//             )}
//           </Row>

//           <Row className="mb-3">
//             <Col lg={6}>
//               <Label for={`formRows[${index}].name`}>Name</Label>
//               <Controller
//                 name={`formRows[${index}].name`}
//                 control={control}
//                 render={({ field }) => (
//                   <Input
//                     type="text"
//                     {...field}
//                     invalid={!!errors.formRows?.[index]?.name}
//                     placeholder="Enter Episode Name"
//                   />
//                 )}
//               />
//               {errors.formRows?.[index]?.name && (
//                 <FormFeedback>
//                   {errors.formRows[index].name.message}
//                 </FormFeedback>
//               )}
//             </Col>
//           </Row>

//           <Row className="mb-3">
//             <Col lg={3}className="d-none">
//               <Label for={`formRows[${index}].duration`}>Duration (seconds)</Label>
//               <Controller
//                 name={`formRows[${index}].duration`}
//                 control={control}

//                 render={({ field }) => (
//                   <Input
//                     type="number"
//                     {...field}
//                     value={field.value || ""}
//                     readOnly
//                   />
//                 )}
//               />
//             </Col>

//             <Col lg={3} className="d-none">
//               <Label for={`formRows[${index}].media_type`}>Media Type</Label>
//               <Controller
//                 name={`formRows[${index}].media_type`}
//                 control={control}
//                 render={({ field }) => (
//                   <Input
//                     type="text"
//                     {...field}
//                     value={field.value === 2 ? "Video" : "Audio"}
//                     readOnly
//                   />
//                 )}
//               />
//             </Col>
//           </Row>
//         </div>
//       ))}
//       <Button
//         type="button"
//         className="btn btn-info mt-3"
//         onClick={() =>
//           append({
//             sorting: "",
//             name: "",
//             media_url: null,
//             duration: null,
//             media_type: "",
//           })
//         }
//       >
//         Add
//       </Button>
//     </>
//   );
// };

// export default EpisodeForm;
